import React from "react";
import { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { MyTextInput } from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import { reset_pass } from "../services/web/webServices";
import { useNavigate, useLocation } from "react-router-dom";

function ResetPassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state.email;
  const token = location.state.passwordResetToken;

  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState(false);
  const [getButton, setButton] = useState(true);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setconfirmPassword(!confirmPassword);
  };
  const css = `

  .login-container {
    max-width: 450px;
    margin: auto;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    marginTop:220px;
    background-color: #263043
    
    
  }
  
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  form {
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  label {
    font-weight: bold;
  }
  
  input {
    width: 100%;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  .password-input {
    position: relative;
  }
  
  .toggle-password {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    cursor: pointer;
    color: #666;
  }
  
  button {
    padding: 12px;
    background-color: #076A33;
     
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  button:hover {
    background-color: #076A33;
  }
    forgot-password{
          display:flex;
          justiy-content:right;
    }
  
    `;
  return (
    <>
      <style>{css}</style>
      <div
        style={{
          backgroundImage: `url(/images/image1.png)`,
          height: "100vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "100px",
        }}
      >
        <div>
          <div className="login-container">
            <img
              src="/images/logo.png"
              alt="logo"
              style={{ margin: "30px", marginLeft: "65px" }}
            />
            <h2>Reset Password</h2>
            <Formik
              initialValues={{
                password: "",
                confirmPassword: "",
                email: email,
                token: token,
              }}
              validationSchema={Yup.object({
                password: Yup.string()
                  .required("Please enter password")
                  .min(8, "Password must be at least 8 characters long")
                  .max(20, "Password cannot exceed 20 characters"),

                confirmPassword: Yup.string()
                  .oneOf([Yup.ref("password"), null], "Password and confirm password must match")
                  .required("Please enter confirm password"),
              })}
              onSubmit={(values, { resetForm }) => {
                setButton(false);

                reset_pass(values)
                  .then((res) => {
                    setButton(true);

                    Store.addNotification({
                      title: "Success",
                      message: res.data?.message,
                      type: "success",
                      insert: "top",
                      container: "top-right",
                      animationIn: ["animate__animated", "animate__fadeIn"],
                      animationOut: ["animate__animated", "animate__fadeOut"],
                      dismiss: {
                        duration: 5000,
                        onScreen: true,
                      },
                    });
                    resetForm({ values: "" });
                    navigate("/");
                  })
                  .catch((error) => {
                    setButton(true);
                    if (error) {
                      // console.log("error", error);

                      Store.addNotification({
                        title: "Error!",
                        message: error?.response?.data?.message,
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animate__animated", "animate__fadeIn"],
                        animationOut: ["animate__animated", "animate__fadeOut"],
                        dismiss: {
                          duration: 5000,
                          onScreen: true,
                        },
                      });
                    }
                  });
              }}
            >
              {(props) => (
                <Form>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="password-input">
                      <MyTextInput
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        placeholder="Enter your password"
                      />
                      <span
                        className="toggle-password"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>

                  <div className="form-group">
                    <label htmlFor="confirmPassword"> Confirm Password</label>
                    <div className="password-input">
                      <MyTextInput
                        type={confirmPassword ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Enter your confirm password"
                      />
                      <span
                        className="toggle-password"
                        onClick={toggleConfirmPasswordVisibility}
                      >
                        {confirmPassword ? "Hide" : "Show"}
                      </span>
                    </div>
                  </div>

                  {getButton === true ? (
                    <button
                      type="submit"
                      style={{ fontSize: "20px", color: "#fff" }}
                    >
                      Submit
                    </button>
                  ) : (
                    <button
                      type="submit"
                      disabled={!getButton}
                      style={{ fontSize: "20px", color: "#fff" }}
                    >
                      Please Wait!!
                    </button>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
